import { motion } from "framer-motion";
import { Briefcase, Zap, Users, Lock } from "lucide-react";
import "../style/IconSection.css";

const IconSection = () => {
    const fadeInUp = {
        hidden: { opacity: 0, y: 30 },
        visible: { opacity: 1, y: 0 }
    };

    const icons = [
        {
            icon: <Briefcase size={96} strokeWidth={2}  color="rgb(23, 93, 252)"/>,
            title: "Made for how trades actually work",
            description: "Designed for plumbers, electricians, builders and cleaners who want to create jobs, manage work, and get paid - without admin headaches."
        },
        {
            icon: <Zap size={96} strokeWidth={2}  color="rgb(23, 93, 252)"/>,
            title: "Up and running in minutes",
            description: "Create your first job in under 2 minutes - most users do it faster."
        },
        {
            icon: <Users size={96} strokeWidth={2}  color="rgb(23, 93, 252)"/>,
            title: "Solo or team - your choice",
            description: "Use DayDone on your own or invite your team. Everyone sees only what they need."
        },
        {
            icon: <Lock size={96} strokeWidth={2}  color="rgb(23, 93, 252)"/>,
            title: "Try it without commitment",
            description: "No card required. 14-day free trial. Cancel anytime."
        }
    ];

    return (
        <section className="icons-section">
            <div className="container">
                <motion.div
                    className="text-center mb-5"
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, margin: "-100px" }}
                    variants={fadeInUp}
                    transition={{ duration: 0.6 }}
                >
                    <h2 className="icons-main-title">
                        Built for Real Trades - Not Office Software
                    </h2>
                </motion.div>

                <motion.div
                    className="row g-5"
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, margin: "-100px" }}
                    variants={{
                        visible: {
                            transition: {
                                staggerChildren: 0.2
                            }
                        }
                    }}
                >
                    {icons.map((icon, index) => (
                        <motion.div
                            key={index}
                            className="col-12"
                            variants={fadeInUp}
                        >
                            <div className="icon-card">
                                <div className="icon-icon-wrapper">
                                    <div className="icon-icon">
                                        {icon.icon}
                                    </div>
                                </div>
                                <div className="icon-content">
                                    <h3 className="icon-title">{icon.title}</h3>
                                    <p className="icon-description">{icon.description}</p>
                                </div>
                            </div>
                        </motion.div>
                    ))}
                </motion.div>
            </div>
        </section>
    );
};

export default IconSection;